/**
 * /my-coaching/business/nova/assets/$assetKey — the layout above one asset's page and,
 * for a collection with item pages, its items' pages. It names the asset in
 * the breadcrumbs and decides once whether the key has a page at all.
 *
 * An unknown key is a 404. A real asset without a page of its own (the score,
 * a coming-soon entry) goes back to the list, where its card knows how to
 * open it.
 */

import {
  createFileRoute,
  notFound,
  Outlet,
  redirect,
} from "@tanstack/react-router";

import {
  assetByKey,
  hasAssetPage,
  isAssetKey,
} from "~/lib/shared/nova/assets/catalog";

export const Route = createFileRoute(
  "/_user/my-coaching/business/nova/assets/$assetKey",
)({
  // The loader's asset label replaces this once the key resolves.
  staticData: { title: "Asset" },
  beforeLoad: ({ params }) => {
    if (!isAssetKey(params.assetKey)) throw notFound();
    const asset = assetByKey(params.assetKey);
    if (!hasAssetPage(asset)) {
      throw redirect({ to: "/my-coaching/business/nova/assets" });
    }
    return { asset };
  },
  loader: ({ context }) => ({ title: context.asset.label }),
  component: () => <Outlet />,
});
